const OBJECT_TYPES = {
  en: [
    { id: 21, title: 'Hotel complex', value: 'hotel-complex' },
    { id: 22, title: 'Residential complex', value: 'residential-complex' },
    { id: 23, title: 'Apartments', value: 'apartments' },
    { id: 24, title: 'Villa', value: 'villa' },
    { id: 25, title: 'Hotel', value: 'hotel' },
    { id: 26, title: 'House', value: 'house' },
    { id: 27, title: 'Maisonette', value: 'maisonette' },
    { id: 28, title: 'Flat', value: 'flat' },
    { id: 29, title: 'Duplex', value: 'duplex' },
    { id: 30, title: 'Chalet', value: 'chalet' },
    { id: 31, title: 'Office', value: 'office' },
    { id: 32, title: 'Parking', value: 'parking' },
    { id: 33, title: 'Yacht berth', value: 'yacht-berth' },
    { id: 34, title: 'Penthouse', value: 'penthouse' },
    { id: 35, title: 'Free purpose', value: 'free-purpose' },
    { id: 36, title: 'Retail', value: 'retail' },
    { id: 37, title: 'Townhouse', value: 'townhouse' },
    { id: 38, title: 'Plot', value: 'plot' },
    { id: 39, title: 'Share', value: 'share' },
    { id: 40, title: 'Bungalow', value: 'bungalow' },
  ],
  de: [
    {
      id: 41,
      title: 'Hotelkomplex',
      value: 'hotel-complex',
    },
    {
      id: 42,
      title: 'Wohnanlage',
      value: 'residential-complex',
    },
    {
      id: 43,
      title: 'Wohnungen',
      value: 'apartments',
    },
    {
      id: 44,
      title: 'Villa',
      value: 'villa',
    },
    {
      id: 45,
      title: 'Hotel',
      value: 'hotel',
    },
    {
      id: 46,
      title: 'Haus',
      value: 'house',
    },
    {
      id: 47,
      title: 'Maisonette',
      value: 'maisonette',
    },
    {
      id: 48,
      title: 'Wohnung',
      value: 'flat',
    },
    {
      id: 49,
      title: 'Duplex',
      value: 'duplex',
    },
    {
      id: 50,
      title: 'Chalet',
      value: 'chalet',
    },
    {
      id: 51,
      title: 'Büro',
      value: 'office',
    },
    {
      id: 52,
      title: 'Parken',
      value: 'parking',
    },
    {
      id: 53,
      title: 'Yachtliegeplatz',
      value: 'yacht-berth',
    },
    {
      id: 54,
      title: 'Penthouse',
      value: 'penthouse',
    },
    {
      id: 55,
      title: 'Freier Zweck',
      value: 'free-purpose',
    },
    {
      id: 56,
      title: 'Einzelhandel',
      value: 'retail',
    },
    {
      id: 57,
      title: 'Stadthaus',
      value: 'townhouse',
    },
    {
      id: 58,
      title: 'Handlung',
      value: 'plot',
    },
    {
      id: 59,
      title: 'Aktie',
      value: 'share',
    },
    {
      id: 60,
      title: 'Bungalow',
      value: 'bungalow',
    },
  ],
  ru: [
    { id: 1, title: 'Отельный комплекс', value: 'hotel-complex' },
    { id: 2, title: 'Жилой комплекс', value: 'residential-complex' },
    { id: 3, title: 'Апартаменты', value: 'apartments' },
    { id: 4, title: 'Вилла', value: 'villa' },
    { id: 5, title: 'Отель', value: 'hotel' },
    { id: 6, title: 'Дом', value: 'house' },
    { id: 7, title: 'Мезонет', value: 'maisonette' },
    { id: 8, title: 'Квартира', value: 'flat' },
    { id: 9, title: 'Дуплекс', value: 'duplex' },
    { id: 10, title: 'Шале', value: 'chalet' },
    { id: 11, title: 'Офис', value: 'office' },
    { id: 12, title: 'Парковка', value: 'parking' },
    { id: 13, title: 'Причал для яхт', value: 'yacht-berth' },
    { id: 14, title: 'Пентхаус', value: 'penthouse' },
    { id: 15, title: 'Помещение свободного назначения', value: 'free-purpose' },
    { id: 16, title: 'Ритейл', value: 'retail' },
    { id: 17, title: 'Таунхаус', value: 'townhouse' },
    { id: 18, title: 'Участок', value: 'plot' },
    { id: 19, title: 'Доля', value: 'share' },
    { id: 20, title: 'Бунгало', value: 'bungalow' },
  ],
  tr: [
    { id: 21, title: 'Otel kompleksi', value: 'hotel-complex' },
    { id: 22, title: 'Konut kompleksi', value: 'residential-complex' },
    { id: 23, title: 'Daireler', value: 'apartments' },
    { id: 24, title: 'Villa', value: 'villa' },
    { id: 25, title: 'Otel', value: 'hotel' },
    { id: 26, title: 'Ev', value: 'house' },
    { id: 27, title: 'Maisonette', value: 'maisonette' },
    { id: 28, title: 'Daire', value: 'flat' },
    { id: 29, title: 'Dubleks', value: 'duplex' },
    { id: 30, title: 'Chalet', value: 'chalet' },
    { id: 31, title: 'Ofis', value: 'office' },
    { id: 32, title: 'Otopark', value: 'parking' },
    { id: 33, title: 'Yat limanı', value: 'yacht-berth' },
    { id: 34, title: 'Çatı katı', value: 'penthouse' },
    { id: 35, title: 'Serbest amaçlı', value: 'free-purpose' },
    { id: 36, title: 'Perakende', value: 'retail' },
    { id: 37, title: 'Townhouse', value: 'townhouse' },
    { id: 38, title: 'Arsa', value: 'plot' },
    { id: 39, title: 'Hisse', value: 'share' },
    { id: 40, title: 'Bungalov', value: 'bungalow' },
  ],
};

const ESTATE_TYPES = {
  en: [
    { id: 4, title: 'Residential', value: 'residential' },
    { id: 5, title: 'Commercial', value: 'commercial' },
    { id: 6, title: 'Investment', value: 'investment' },
  ],
  de: [
    { id: 7, title: 'Wohnen', value: 'residential' },
    { id: 8, title: 'Kommerziell', value: 'commercial' },
    { id: 9, title: 'Investition', value: 'investment' },
  ],
  ru: [
    { id: 1, title: 'Жилая', value: 'residential' },
    { id: 2, title: 'Коммерческая', value: 'commercial' },
    { id: 3, title: 'Инвестиционная', value: 'investment' },
  ],
  tr: [
    { id: 4, title: 'Konut', value: 'residential' },
    { id: 5, title: 'Ticari', value: 'commercial' },
    { id: 6, title: 'Yatırım', value: 'investment' },
  ],
};

const OBJECT_STAGES = {
  en: [
    { id: 4, title: 'Design', value: 'design' },
    { id: 5, title: 'Construction', value: 'construction' },
    { id: 6, title: 'Ready', value: 'ready' },
  ],
  de: [
    { id: 7, title: 'Design', value: 'design' },
    { id: 8, title: 'Konstruktion', value: 'construction' },
    { id: 9, title: 'Bereit', value: 'ready' },
  ],
  ru: [
    { id: 1, title: 'Проектирование', value: 'design' },
    { id: 2, title: 'Строительство', value: 'construction' },
    { id: 3, title: 'Готовый', value: 'ready' },
  ],
  tr: [
    { id: 4, title: 'Tasarım', value: 'design' },
    { id: 5, title: 'İnşaat', value: 'construction' },
    { id: 6, title: 'Hazır', value: 'ready' },
  ],
};

const OBJECT_CATEGORIES = {
  en: [
    { id: 6, title: 'New house', value: 'new' },
    { id: 7, title: 'Resale property', value: 'secondary' },
    { id: 8, title: 'Renovation', value: 'renovation' },
    { id: 9, title: 'Reconstruction', value: 'reconstruction' },
    {
      id: 10,
      title: 'Several objects completed, several under construction',
      value: 'partially-ready',
    },
  ],
  de: [
    {
      id: 11,
      title: 'Neues Haus',
      value: 'new',
    },
    {
      id: 12,
      title: 'Wiederverkaufsimmobilie',
      value: 'secondary',
    },
    {
      id: 13,
      title: 'Renovierung',
      value: 'renovation',
    },
    {
      id: 14,
      title: 'Wiederaufbau',
      value: 'reconstruction',
    },
    {
      id: 15,
      title: 'Mehrere Objekte fertiggestellt, mehrere im Bau',
      value: 'partially-ready',
    },
  ],
  ru: [
    { id: 1, title: 'Новый дом', value: 'new' },
    { id: 2, title: 'Вторичная недвижимость', value: 'secondary' },
    { id: 3, title: 'Реновация', value: 'renovation' },
    { id: 4, title: 'Реконструкция', value: 'reconstruction' },
    { id: 5, title: 'Несколько объектов готовы', value: 'partially-ready' },
  ],
  tr: [
    { id: 6, title: 'Yeni ev', value: 'new' },
    { id: 7, title: 'İkinci el emlak', value: 'secondary' },
    { id: 8, title: 'Yenileme', value: 'renovation' },
    { id: 9, title: 'Rekonstrüksiyon', value: 'reconstruction' },
    {
      id: 10,
      title: 'Bazı projeler tamamlandı, bazıları inşaat aşamasında',
      value: 'partially-ready',
    },
  ],
};

const FURNITURES = {
  en: [
    { id: 6, title: 'Furnished', value: 'furnished' },
    { id: 7, title: 'Partially furnished', value: 'partially-furnished' },
    { id: 8, title: 'Designer furniture', value: 'designer-furniture' },
    { id: 9, title: 'Unfurnished', value: 'unfurnished' },
    { id: 10, title: 'Additionally', value: 'additionally' },
  ],
  de: [
    {
      id: 26,
      title: 'Möbliert',
      value: 'furnished',
    },
    {
      id: 27,
      title: 'Teilmöbliert',
      value: 'partially-furnished',
    },
    {
      id: 28,
      title: 'Designermöbel',
      value: 'designer-furniture',
    },
    {
      id: 29,
      title: 'Unmöbliert',
      value: 'unfurnished',
    },
    {
      id: 30,
      title: 'Zusätzlich',
      value: 'additionally',
    },
  ],
  ru: [
    { id: 1, title: 'Меблированный', value: 'furnished' },
    { id: 2, title: 'Частично меблированный', value: 'partially-furnished' },
    { id: 3, title: 'Дизайнерская мебель', value: 'designer-furniture' },
    { id: 4, title: 'Без мебели', value: 'unfurnished' },
    { id: 5, title: 'Дополнительно', value: 'additionally' },
  ],
  tr: [
    { id: 6, title: 'Eşyalı', value: 'furnished' },
    { id: 7, title: 'Kısmen eşyalı', value: 'partially-furnished' },
    { id: 8, title: 'Tasarımcı mobilyalar', value: 'designer-furniture' },
    { id: 9, title: 'Eşyasız', value: 'unfurnished' },
    { id: 10, title: 'Ek olarak', value: 'additionally' },
  ],
};

const VIEWS = {
  en: [
    { id: 12, title: 'Sea', value: 'sea' },
    { id: 13, title: 'City', value: 'city' },
    { id: 14, title: 'Lake', value: 'lake' },
    { id: 15, title: 'Forest', value: 'forest' },
    { id: 16, title: 'Garden', value: 'garden' },
    { id: 17, title: 'Mountain', value: 'mountain' },
    { id: 18, title: 'Ocean', value: 'ocean' },
    { id: 19, title: 'Plot', value: 'plot' },
    { id: 20, title: 'Pool', value: 'pool' },
    { id: 21, title: 'River', value: 'river' },
    { id: 22, title: 'Road', value: 'road' },
  ],
  de: [
    {
      id: 32,
      title: 'Meer',
      value: 'sea',
    },
    {
      id: 33,
      title: 'Stadt',
      value: 'city',
    },
    {
      id: 34,
      title: 'See',
      value: 'lake',
    },
    {
      id: 35,
      title: 'Wald',
      value: 'forest',
    },
    {
      id: 36,
      title: 'Garten',
      value: 'garden',
    },
    {
      id: 37,
      title: 'Berg',
      value: 'mountain',
    },
    {
      id: 38,
      title: 'Ozean',
      value: 'ocean',
    },
    {
      id: 39,
      title: 'Handlung',
      value: 'plot',
    },
    {
      id: 40,
      title: 'Schwimmbad',
      value: 'pool',
    },
    {
      id: 41,
      title: 'Fluss',
      value: 'river',
    },
    {
      id: 42,
      title: 'Straße',
      value: 'road',
    },
  ],
  ru: [
    { id: 1, title: 'Море', value: 'sea' },
    { id: 2, title: 'Город', value: 'city' },
    { id: 3, title: 'Озеро', value: 'lake' },
    { id: 4, title: 'Лес', value: 'forest' },
    { id: 5, title: 'Сад', value: 'garden' },
    { id: 6, title: 'Горы', value: 'mountain' },
    { id: 7, title: 'Океан', value: 'ocean' },
    { id: 8, title: 'Участок', value: 'plot' },
    { id: 9, title: 'Бассейн', value: 'pool' },
    { id: 10, title: 'Река', value: 'river' },
    { id: 11, title: 'Дорога', value: 'road' },
  ],
  tr: [
    { id: 12, title: 'Deniz', value: 'sea' },
    { id: 13, title: 'Şehir', value: 'city' },
    { id: 14, title: 'Göl', value: 'lake' },
    { id: 15, title: 'Orman', value: 'forest' },
    { id: 16, title: 'Bahçe', value: 'garden' },
    { id: 17, title: 'Dağ', value: 'mountain' },
    { id: 18, title: 'Okyanus', value: 'ocean' },
    { id: 19, title: 'Arazi', value: 'plot' },
    { id: 20, title: 'Havuz', value: 'pool' },
    { id: 21, title: 'Nehir', value: 'river' },
    { id: 22, title: 'Yol', value: 'road' },
  ],
};

const REGISTRATION_FEATURES = {
  en: [
    { id: 5, title: 'Ownership', value: 'ownership' },
    { id: 6, title: 'Share', value: 'share' },
    { id: 7, title: 'Long term leasehold', value: 'long-term-leasehold' },
    { id: 8, title: 'Pledged property', value: 'pledged-property' },
  ],
  de: [
    {
      id: 25,
      title: 'Eigentum',
      value: 'ownership',
    },
    {
      id: 26,
      title: 'Aktie',
      value: 'share',
    },
    {
      id: 27,
      title: 'Langfristige Erbpacht',
      value: 'long-term-leasehold',
    },
    {
      id: 28,
      title: 'Verpfändetes Eigentum',
      value: 'pledged-property',
    },
  ],
  ru: [
    { id: 1, title: 'Собственность', value: 'ownership' },
    { id: 2, title: 'Доля', value: 'share' },
    { id: 3, title: 'Право долгосрочной аренды', value: 'long-term-leasehold' },
    { id: 4, title: 'Залоговое имущество', value: 'pledged-property' },
  ],
  tr: [
    { id: 5, title: 'Mülkiyet', value: 'ownership' },
    { id: 6, title: 'Pay', value: 'share' },
    { id: 7, title: 'Uzun süreli kira hakkı', value: 'long-term-leasehold' },
    { id: 8, title: 'Rehinli mülk', value: 'pledged-property' },
  ],
};

const ISLAND = {
  en: [
    { id: 3, title: 'Mainland', value: 'false' },
    { id: 4, title: 'Island', value: 'true' },
  ],
  de: [
    { id: 5, title: 'Festland', value: 'false' },
    { id: 6, title: 'Insel', value: 'true' },
  ],
  ru: [
    { id: 1, title: 'Материк', value: 'false' },
    { id: 2, title: 'Остров', value: 'true' },
  ],
  tr: [
    { id: 3, title: 'Anakarası', value: 'false' },
    { id: 4, title: 'Adalar', value: 'true' },
  ],
};

const SELECT_TRUE_FALSE = {
  en: [
    { id: 3, title: 'Yes', value: 'true' },
    { id: 4, title: 'No', value: 'false' },
  ],
  de: [
    { id: 5, title: 'Ja', value: 'true' },
    { id: 6, title: 'Nein', value: 'false' },
  ],
  ru: [
    { id: 1, title: 'Да', value: 'true' },
    { id: 2, title: 'Нет', value: 'false' },
  ],
  tr: [
    { id: 3, title: 'Evet', value: 'true' },
    { id: 4, title: 'Hayır', value: 'false' },
  ],
};

export const realEstateFiltersDict = {
  objectTypes: OBJECT_TYPES,
  estateTypes: ESTATE_TYPES,
  objectStages: OBJECT_STAGES,
  objectCategories: OBJECT_CATEGORIES,
  furnitures: FURNITURES,
  views: VIEWS,
  registrationFeatures: REGISTRATION_FEATURES,
  island: ISLAND,
  selectTrueFalse: SELECT_TRUE_FALSE,
};
